import { invoicingHistoryAlert } from 'vcomponents/listing/helpers/listingAlerts';
import Feature from 'Services/Feature';

// TODO: once `overview-info-sidebar` ships to 100% and the legacy overview is killed, drop the
// `overview-info-sidebar` check and the FF itself — only `einvoicing-routing-addresses` will gate
// the routing-addresses feature.
const isRoutingAddressesAvailable = () =>
    Feature.isEnabled('einvoicing-routing-addresses') && Feature.isEnabled('overview-info-sidebar');

var dataMap = {
    informations: [
        {
            label: window.i18n.__('Nom'),
            id: 'name',
            format: 'text',
            favoriteName: 'informations_name',
            'data-bot': 'overview__general-info--name',
        },
        {
            label: window.i18n.__('Site web'),
            id: 'domain',
            format: 'external_url',
            favoriteName: 'informations_domain',
            'data-bot': 'overview__general-info--website',
        },
        {
            label: window.i18n.__('Téléphone'),
            id: 'phone',
            format: 'phone',
            favoriteName: 'informations_phone',
            'data-bot': 'overview__general-info--phone',
        },
        {
            label: window.i18n.__('Mobile'),
            id: 'mobile',
            format: 'phone',
            favoriteName: 'informations_mobile',
            'data-bot': 'overview__general-info--mobile',
        },
        {
            label: window.i18n.__('Fax'),
            id: 'fax',
            format: 'phone',
            favoriteName: 'informations_fax',
            'data-bot': 'overview__general-info--fax',
        },
        {
            label: window.i18n.__('Email'),
            id: 'email',
            format: 'email',
            favoriteName: 'informations_email',
            'data-bot': 'overview__general-info--email',
        },
        {
            label: window.i18n.__('Facebook'),
            id: 'facebook',
            format: 'external_url',
            favoriteName: 'informations_facebook',
            'data-bot': 'overview__general-info--facebook',
        },
        {
            label: window.i18n.__('X (Twitter)'),
            id: 'twitter',
            format: 'external_url',
            favoriteName: 'informations_twitter',
            'data-bot': 'overview__general-info--twitter',
        },
        {
            label: window.i18n.__('Linkedin'),
            id: 'linkedin',
            format: 'external_url',
            favoriteName: 'informations_linkedin',
            'data-bot': 'overview__general-info--linkedin',
        },
    ],
    contacts: [
        {
            label: window.i18n.__('Contact principal'),
            id: 'fullName',
            format: 'link',
            favoriteName: 'contacts_fullName',
            'data-bot': 'overview__main-contact',
        },
        {
            label: window.i18n.__('Fonction'),
            id: 'position',
            format: 'text',
            favoriteName: 'contacts_position',
        },
        {
            label: window.i18n.__('Email'),
            id: 'email',
            format: 'email',
            favoriteName: 'contacts_email',
            'data-bot': 'overview__main-email',
        },
        {
            label: window.i18n.__('Téléphone'),
            id: 'phone',
            format: 'phone',
            favoriteName: 'contacts_phone',
            'data-bot': 'overview__main-phone',
        },
        {
            label: window.i18n.__('Mobile'),
            id: 'mobile',
            format: 'phone',
            favoriteName: 'contacts_mobile',
            'data-bot': 'overview__main-mobile',
        },
    ],
    financial: [
        {
            label: window.i18n.__('Compte tiers'),
            id: 'account',
            format: 'text',
            favoriteName: 'financial_account',
            'data-bot': 'overview__general-info--third-parties',
        },
        {
            label: window.i18n.__('Code compte auxiliaire'),
            id: 'auxiliaryCode',
            format: 'text',
            favoriteName: 'financial_auxiliaryCode',
            'data-bot': 'overview__general-info--subaccount-code',
        },
        {
            label: window.i18n.__('Catégorie tarifaire'),
            id: 'rateCategory',
            format: 'text',
            favoriteName: 'financial_rateCategory',
            'data-bot': 'overview__general-info--rate-category',
        },
        {
            label: window.i18n.__('N° TVA intracommunautaire'),
            id: 'vatNum',
            format: 'text',
            favoriteName: 'financial_vatNum',
            'data-bot': 'overview__general-info--vat',
        },
        {
            label: window.i18n.__('Référence'),
            id: 'reference',
            format: 'text',
            favoriteName: 'financial_reference',
            'data-bot': 'overview__general-info--reference',
        },
    ],
    legal: [
        {
            label: window.i18n.__('Forme juridique'),
            id: 'companyStatus',
            format: 'text',
            favoriteName: 'legal_companyStatus',
            'data-bot': 'overview__general-info--company-type',
        },
        {
            label: window.i18n.__('SIREN'),
            id: 'siren',
            format: 'text',
            favoriteName: 'legal_siren',
            'data-bot': 'overview__general-info--siren',
        },
        {
            label: window.i18n.__('SIRET'),
            id: 'siret',
            format: 'text',
            favoriteName: 'legal_siret',
            'data-bot': 'overview__general-info--siret',
        },
        {
            label: window.i18n.__('Code NAF'),
            id: 'ape',
            format: 'text',
            favoriteName: 'legal_ape',
            'data-bot': 'overview__general-info--ape-naf',
        },
        {
            label: window.i18n.__('RCS'),
            id: 'rcs',
            format: 'text',
            favoriteName: 'legal_rcs',
            'data-bot': 'overview__general-info--rcs',
        },
        {
            label: window.i18n.__('Capital social'),
            id: 'capital',
            format: 'text',
            favoriteName: 'legal_capital',
            'data-bot': 'overview__general-info--capital',
        },
    ],
};

var navMap = [
    {
        id: 'informations',
        label: '',
        items: [
            {
                id: 'activity',
                label: window.i18n.__('Activité'),
                group: false,
                component: 'tab-activity',
                permission: 'can_show_activity',
                keepalive: false,
                more: {},
            },
            {
                id: 'informations',
                label: window.i18n.__('Informations générales'),
                group: false,
                component: 'tab-informations-third',
                more: {},
            },
            {
                id: 'preferences',
                label: window.i18n.__('Préférences'),
                group: false,
                component: 'tab-preferences',
                more: {
                    buttons: [
                        {
                            type: 'function',
                            label: window.i18n.__('Editer'),
                            primary: true,
                            permission: 'can_edit',
                            event: 'edit',
                            params: {},
                        },
                    ],
                },
            },
            {
                id: 'financialactivity',
                label: window.i18n.__('Informations financières'),
                group: false,
                component: 'tab-financial-activity',
                more: {
                    buttons: [
                        {
                            label: window.i18n.__("Compléter via l'annuaire"),
                            callback: 'javascript: CompanySearch.modalUpdate({linkedid});',
                            permission: 'can_edit',
                            primary: true,
                        },
                    ],
                },
            },
            {
                id: 'contacts',
                label: window.i18n.__('Contacts associés'),
                group: false,
                component: 'tab-contacts',
                permission: 'can_show_contacts',
                more: {
                    buttons: [
                        {
                            label: window.i18n.__('Ajouter / Lier un contact'),
                            callback: "javascript:People.linkTo('third', {id});",
                            primary: true,
                        },
                    ],
                },
            },
            {
                id: 'addresses',
                // Label is whichever the user sees in the nav:
                // - flat entry when routing addresses are off → "Adresses" parent label
                // - sub-item under an "Adresses" group when on → "Adr. postales"
                // Read lazily so Feature is ready at call time (Feature.set() runs at boot,
                // after this module is evaluated, so a direct call would throw).
                get label() {
                    return isRoutingAddressesAvailable()
                        ? window.i18n.__('Adr. postales')
                        : window.i18n.__('Adresses');
                },
                // Group lazily so the FFs are read at runtime, and so buildNav() can choose
                // between flat or grouped layout based on the result.
                get group() {
                    return isRoutingAddressesAvailable()
                        ? { id: 'addresses-group', label: window.i18n.__('Adresses') }
                        : false;
                },
                component: 'tab-addresses',
                permission: 'can_show_addresses',
                more: {
                    buttons: [
                        {
                            id: 'add',
                            type: 'function',
                            label: window.i18n.__('Ajouter une adresse'),
                            primary: true,
                            permission: 'can_create_addresses',
                            event: 'openAddress',
                        },
                        {
                            id: 'seemap',
                            type: 'function',
                            label: window.i18n.__('Voir la carte'),
                            primary: false,
                            event: 'openAddressMap',
                            dataUpsell: 'map_listing',
                        },
                    ],
                },
            },
            {
                id: 'routing-addresses',
                label: window.i18n.__('Adr. de routage'),
                group: { id: 'addresses-group', label: window.i18n.__('Adresses') },
                feature: ['einvoicing-routing-addresses', 'overview-info-sidebar'],
                component: 'tab-routing-addresses',
                permission: 'can_show_addresses',
                more: { buttons: [] },
            },
            {
                id: 'customfields',
                label: window.i18n.__('Champs personnalisés'),
                group: false,
                component: 'tab-customfields',
                more: {
                    url: '/rest/thirds/{linkedid}/custom-field-values',
                    buttons: [
                        {
                            type: 'function',
                            label: window.i18n.__('Editer'),
                            primary: true,
                            permission: 'can_edit',
                            event: 'openCustomfields',
                            params: {},
                        },
                    ],
                },
            },
            {
                id: 'statistics',
                label: window.i18n.__('Statistiques'),
                group: false,
                component: 'tab-statistics',
                more: {},
            },
        ],
    },
    {
        id: 'plugin',
        label: window.i18n.__('Modules'),
        items: [
            {
                id: 'opportunity',
                label: window.i18n.__('Opportunités'),
                group: false,
                component: 'tab-listing',
                permission: 'can_show_opportunity',
                more: {
                    linkedtype: 'opportunities',
                    name: 'lightened-opportunities',
                    url: '/prospection/opportunities',
                    title: window.i18n.__('Opportunités'),
                    enableExport: false,
                    buttons: [
                        {
                            type: 'function',
                            label: window.i18n.__('Créer une opportunité'),
                            primary: true,
                            permission: 'create',
                            url: {
                                event: 'openOpportunity',
                                params: {},
                            },
                        },
                    ],
                },
            },
            {
                id: 'estimate',
                label: window.i18n.__('Devis'),
                group: {
                    id: 'documents',
                    label: window.i18n.__('Documents'),
                },
                component: 'tab-listing',
                permission: 'can_show_invoicing_docs_estimate',
                more: {
                    linkedtype: 'estimate',
                    name: 'lightened-saleestimates',
                    url: '/prospection/estimate',
                    title: window.i18n.__('Devis'),
                    enableExport: false,
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: window.i18n.__('Créer un devis'),
                            permission: 'create',
                            relatedPermission: 'can_create_invoicing_docs_estimate',
                            href: "javascript:DocTools.createForThird('estimate', 'Créer un devis', true, null, {linkedid})",
                        },
                    ],
                },
            },
            {
                id: 'invoiceDraft',
                label: window.i18n.__('Factures brouillon'),
                group: {
                    id: 'documents',
                    label: window.i18n.__('Documents'),
                },
                component: 'tab-listing',
                permission: 'can_show_invoicing_docs_invoice',
                feature: 'numbering-draft',
                more: {
                    linkedtype: 'invoice',
                    alerts: [invoicingHistoryAlert],
                    name: 'lightened-saleinvoices-draft',
                    url: '/sales/invoice/draft',
                    title: window.i18n.__('Factures brouillon'),
                    enableExport: false,
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: window.i18n.__('Créer une facture'),
                            permission: 'create',
                            relatedPermission: 'can_create_invoicing_docs_invoice',
                            href: "javascript:DocTools.createForThird('invoice', 'Créer une facture', true, null, {linkedid})",
                        },
                    ],
                },
            },
            {
                id: 'invoice',
                label: window.i18n.__('Factures'),
                group: {
                    id: 'documents',
                    label: window.i18n.__('Documents'),
                },
                component: 'tab-listing',
                permission: 'can_show_invoicing_docs_invoice',
                more: {
                    linkedtype: 'invoice',
                    alerts: [invoicingHistoryAlert],
                    name: 'lightened-saleinvoices',
                    url: '/sales/invoice',
                    title: window.i18n.__('Factures'),
                    enableExport: false,
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: window.i18n.__('Créer une facture'),
                            permission: 'create',
                            relatedPermission: 'can_create_invoicing_docs_invoice',
                            href: "javascript:DocTools.createForThird('invoice', 'Créer une facture', true, null, {linkedid})",
                        },
                    ],
                },
            },
            {
                id: 'delivery',
                label: window.i18n.__('Bon de livraison'),
                group: {
                    id: 'documents',
                    label: window.i18n.__('Documents'),
                },
                component: 'tab-listing',
                permission: 'can_show_invoicing_docs_delivery',
                more: {
                    linkedtype: 'delivery',
                    name: 'lightened-saledeliveries',
                    url: '/prospection/delivery',
                    title: window.i18n.__('Bons de livraison'),
                    enableExport: false,
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: window.i18n.__('Créer un bon de livraison'),
                            permission: 'create',
                            relatedPermission: 'can_create_invoicing_docs_delivery',
                            href: "javascript:DocTools.createForThird('delivery', 'Créer un bon de livraison', true, null, {linkedid})",
                        },
                    ],
                },
            },
            {
                id: 'order',
                label: window.i18n.__('Bon de commande'),
                group: {
                    id: 'documents',
                    label: window.i18n.__('Documents'),
                },
                component: 'tab-listing',
                permission: 'can_show_invoicing_docs_order',
                more: {
                    linkedtype: 'order',
                    name: 'lightened-saleorders',
                    url: '/prospection/order',
                    title: window.i18n.__('Bons de commande'),
                    enableExport: false,
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: window.i18n.__('Créer un bon de commande'),
                            permission: 'create',
                            relatedPermission: 'can_create_invoicing_docs_order',
                            href: "javascript:DocTools.createForThird('order', 'Créer un bon de commande', true, null, {linkedid})",
                        },
                    ],
                },
            },
            {
                id: 'creditnoteDraft',
                label: window.i18n.__('Avoir brouillon'),
                group: {
                    id: 'documents',
                    label: window.i18n.__('Documents'),
                },
                component: 'tab-listing',
                permission: 'can_show_invoicing_docs_creditnote',
                feature: 'numbering-draft',
                more: {
                    linkedtype: 'creditnote',
                    alerts: [invoicingHistoryAlert],
                    name: 'lightened-salecreditnotes-draft',
                    url: '/prospection/creditnote/draft',
                    title: window.i18n.__('Avoirs brouillon'),
                    enableExport: false,
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: window.i18n.__('Créer un avoir'),
                            permission: 'create',
                            relatedPermission: 'can_create_invoicing_docs_creditnote',
                            href: "javascript:DocTools.createForThird('creditnote', 'Créer un avoir', true, null, {linkedid})",
                        },
                    ],
                },
            },
            {
                id: 'creditnote',
                label: window.i18n.__('Avoir'),
                group: {
                    id: 'documents',
                    label: window.i18n.__('Documents'),
                },
                component: 'tab-listing',
                permission: 'can_show_invoicing_docs_creditnote',
                more: {
                    linkedtype: 'creditnote',
                    alerts: [invoicingHistoryAlert],
                    name: 'lightened-salecreditnotes',
                    url: '/prospection/creditnote',
                    title: window.i18n.__('Avoirs'),
                    enableExport: false,
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: window.i18n.__('Créer un avoir'),
                            permission: 'create',
                            relatedPermission: 'can_create_invoicing_docs_creditnote',
                            href: "javascript:DocTools.createForThird('creditnote', 'Créer un avoir', true, null, {linkedid})",
                        },
                    ],
                },
            },
            {
                id: 'proforma',
                label: window.i18n.__('Facture proforma'),
                group: {
                    id: 'documents',
                    label: window.i18n.__('Documents'),
                },
                component: 'tab-listing',
                permission: 'can_show_invoicing_docs_proforma',
                more: {
                    linkedtype: 'proforma',
                    name: 'lightened-saleproformas',
                    url: '/prospection/proforma',
                    title: window.i18n.__('Factures proforma'),
                    enableExport: false,
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: window.i18n.__('Créer une facture proforma'),
                            permission: 'create',
                            relatedPermission: 'can_create_invoicing_docs_proforma',
                            href: "javascript:DocTools.createForThird('proforma', 'Créer une facture proforma', true, null, {linkedid})",
                        },
                    ],
                },
            },
            {
                id: 'payments',
                label: window.i18n.__('Règlements'),
                group: false,
                component: 'tab-listingv1',
                permission: 'can_show_payments',
                more: {
                    title: window.i18n.__('Règlements'),
                    listingname: 'payments',
                    url: '/?_f=third',
                    action: 'loadListingTab',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: window.i18n.__('Ajouter un règlement'),
                            permission: true,
                            callback: "javascript:Payment.edit('', {linkedid})",
                        },
                    ],
                },
            },
            {
                id: 'bankaccount',
                label: window.i18n.__('Comptes & Cartes bancaires'),
                group: false,
                component: 'tab-account-credit-card',
                permission: 'can_edit',
                more: {
                    title: window.i18n.__('Comptes & Cartes bancaires"'),
                    buttons: [],
                },
            },
            {
                id: 'recurring',
                label: window.i18n.__('Abonnements'),
                group: false,
                component: 'tab-listingv1',
                permission: 'can_show_recurring',
                more: {
                    title: window.i18n.__('Abonnements'),
                    listingname: 'recurring',
                    url: '/?_f=third',
                    action: 'loadListingTab',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: window.i18n.__('Créer un abonnement'),
                            permission: 'can_create_recurring',
                            callback: 'DocRecurring.editRecurring(0, {linkedid});',
                        },
                    ],
                },
            },
            {
                id: 'mandates',
                label: window.i18n.__('Mandats'),
                group: false,
                component: 'tab-listingv1',
                permission: 'can_show_mandates',
                more: {
                    title: window.i18n.__('Mandats'),
                    listingname: 'mandates',
                    url: '/?_f=gocardless_mandates',
                    action: 'loadListingTab',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: window.i18n.__('Importer des mandats'),
                            permission: true,
                            callback: 'GoCardless.importPopup({linkedid});',
                        },
                        {
                            type: 'vuejs',
                            primary: true,
                            label: window.i18n.__('Inviter à la prise de mandat'),
                            permission: 'can_show_mandates',
                            event: 'sendemail',
                        },
                    ],
                },
            },
            {
                id: 'timetracking',
                label: window.i18n.__('Timetracking'),
                group: false,
                component: 'tab-listingv1',
                permission: 'can_show_timetracking',
                more: {
                    title: window.i18n.__('Timetracking'),
                    listingname: 'timetracking',
                    url: '/?_f=third',
                    action: 'loadListingTab',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: window.i18n.__('Créer une entrée'),
                            permission: true,
                            callback:
                                "javascript:TimetrackingEntry.edit('', '', '', '', {linkedid});",
                        },
                    ],
                },
            },
            {
                id: 'tickets',
                label: window.i18n.__('Support'),
                group: false,
                component: 'tab-2-columns',
                permission: 'can_show_tickets',
                more: {
                    title: window.i18n.__('Support'),
                    url: '/?_f=support_tickets',
                    action: 'loadThirdTab',
                    thirdid: '{linkedid}',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: window.i18n.__('Créer un ticket'),
                            permission: 'can_create_ticket',
                            callback: 'javascript:Ticket.add({linkedid});',
                        },
                    ],
                },
            },
            {
                id: 'project',
                label: window.i18n.__('Projets'),
                group: false,
                component: 'tab-listingv1',
                permission: 'can_show_project',
                more: {
                    title: window.i18n.__('Projets'),
                    listingname: 'project',
                    url: '/?_f=third',
                    action: 'loadListingTab',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: window.i18n.__('Créer un projet'),
                            permission: 'can_create_project',
                            callback: 'javascript:project.projectForm();',
                        },
                    ],
                },
            },
            {
                id: 'proposal',
                label: window.i18n.__('Documents redactor'),
                group: false,
                component: 'tab-listingv1',
                permission: 'can_show_proposal',
                more: {
                    title: window.i18n.__('Documents redactor'),
                    listingname: 'proposal',
                    url: '/?_f=tabs',
                    action: 'loadListingTab',
                    context: 'third',
                    prefilter: '{"third": {linkedid}}',
                    buttons: [
                        {
                            type: 'js',
                            primary: true,
                            label: window.i18n.__('Créer un document redactor'),
                            permission: 'can_create_proposal_document',
                            callback: "javascript:Proposal.create('propdocument');",
                        },
                    ],
                },
            },
            {
                id: 'emailingprofile',
                label: window.i18n.__('Profil emailing'),
                group: {
                    id: 'mailinglist',
                    label: window.i18n.__('Mailing lists'),
                },
                component: 'tab-listingv1',
                permission: 'can_show_mailinglist',
                more: {
                    tabType: 'total',
                    callbackKeyName: 'massMailingProfile',
                    title: window.i18n.__("Profil d'emailing"),
                    listingname: '',
                    url: '/?_f=massmailing_ajax',
                    action: 'loadMassMailingContactProfile',
                    type: 'corporation',
                    id: '{linkedid}',
                    buttons: [],
                },
            },
            {
                id: 'massmailingMailingList',
                label: window.i18n.__('Mailing lists'),
                group: {
                    id: 'mailinglist',
                    label: window.i18n.__('Mailing lists'),
                },
                component: 'tab-listingv1',
                permission: 'can_show_mailinglist',
                more: {
                    title: window.i18n.__('Mailing lists'),
                    listingname: 'massmailingMailinglist',
                    url: '/?_f=massmailing_ajax',
                    action: 'loadMassMailingContactListingTab',
                    type: 'third',
                    id: '{linkedid}',
                    buttons: [],
                },
            },
            {
                id: 'massmailingCampaignList',
                label: window.i18n.__('Liste des campagnes'),
                group: {
                    id: 'mailinglist',
                    label: window.i18n.__('Mailing lists'),
                },
                component: 'tab-listingv1',
                permission: 'can_show_mailinglist',
                more: {
                    title: window.i18n.__('Liste des campagnes'),
                    listingname: 'massmailingCampaignList',
                    url: '/?_f=massmailing_ajax',
                    action: 'loadMassMailingContactListingTab',
                    type: 'corporation',
                    id: '{linkedid}',
                    buttons: [],
                },
            },
            {
                id: 'receipts',
                label: window.i18n.__('Caisse'),
                group: false,
                component: 'tab-listingv1',
                permission: 'can_show_receipts',
                more: {
                    title: window.i18n.__('Caisse'),
                    listingname: 'receipts',
                    url: '/?_f=third',
                    action: 'loadListingTab',
                    buttons: [],
                },
            },
            {
                id: 'briefcase',
                label: window.i18n.__('Fichiers'),
                group: false,
                component: 'tab-briefcase',
                permission: 'can_show_briefcase',
                more: {
                    title: '',
                    url: '/?_f=briefcasev2',
                    action: 'loadBriefcaseTab',
                    linkedid: '{linkedid}',
                    linkedtype: '{linkedtype}',
                    linkedtypeDir: 'thirds',
                    linkedname: '{linkedname}',
                    editpermission: 'editclient',
                    buttons: [],
                },
            },
        ],
    },
];

// SELLSYADMIN
// - Common tabs for SAM & SellsyAdmin
var sellsyAdminCommonTabs = [
    {
        id: 'samHistory',
        label: window.i18n.__('Histo actions admin'),
        group: {
            id: 'sam',
            label: window.i18n.__('SAM'),
        },
        component: 'tab-listingv1',
        permission: 'can_edit',
        more: {
            tabType: 'total',
            callbackKeyName: 'logs',
            title: '',
            listingname: '',
            url: '/?_f=logs',
            action: 'loadTab',
            relatedtype: 'sellsyadmin',
            relatedid: '{linkedid}',
            buttons: [],
        },
    },
    {
        id: 'samPlugins',
        label: window.i18n.__('Modules et crédits'),
        group: {
            id: 'sam',
            label: window.i18n.__('SAM'),
        },
        component: 'tab-listingv1',
        permission: 'can_edit',
        more: {
            tabType: 'total',
            callbackKeyName: 'tabContent',
            title: '',
            url: '/?_f=sellsyadmin_thirdaddon',
            action: 'loadAccountTab',
            corpid: '{corpid}',
            buttons: [],
        },
    },
    {
        id: 'samReferral',
        label: window.i18n.__('Parrainage'),
        group: {
            id: 'sam',
            label: window.i18n.__('SAM'),
        },
        component: 'tab-listingv1',
        permission: 'can_edit',
        more: {
            tabType: 'total',
            callbackKeyName: 'tabContent',
            title: '',
            url: '/?_f=sellsyadmin_thirdaddon',
            action: 'loadAffiliationTab',
            corpid: '{corpid}',
            buttons: [],
        },
    },
    {
        id: 'samQuota',
        label: window.i18n.__('Provisions - Quota'),
        group: {
            id: 'sam',
            label: window.i18n.__('SAM'),
        },
        component: 'tab-listingv1',
        permission: 'can_edit',
        more: {
            tabType: 'total',
            title: '',
            listingname: 'provision',
            url: '/?_f=tabs',
            action: 'loadListingTab',
            corpid: '{corpid}',
            context: 'third',
            prefilter: '{"corpid": "{corpid}"}',
            buttons: [],
        },
    },
    {
        id: 'samTerms',
        label: window.i18n.__('Conditions Générales'),
        group: {
            id: 'sam',
            label: window.i18n.__('SAM'),
        },
        component: 'tab-sam-terms-list',
        more: {
            url: '/rest/sellsy-account-manager/corporation/{corpid}/terms',
            corpid: '{corpid}',
            prefilter: '{"corpid": "{corpid}"}',
            buttons: [],
        },
        keepalive: false,
    },
];

// - SAM exclusive tabs
var samTabs = [
    {
        id: 'samCarts',
        label: window.i18n.__('Paniers'),
        group: {
            id: 'sam',
            label: window.i18n.__('SAM'),
        },
        component: 'tab-sam-carts-list',
        more: {
            url: '/rest/sellsy-account-manager/corporation/{corpid}/carts',
            corpid: '{corpid}',
            prefilter: '{"corpid": "{corpid}"}',
            buttons: [
                {
                    id: 'add',
                    type: 'vuejs',
                    label: window.i18n.__('Créer un panier'),
                    primary: true,
                    event: 'sam:cart:create',
                    permission: 'sam_can_create_cart',
                },
            ],
        },
        keepalive: false,
    },
];

var moreNav = [
    {
        id: 'connection',
        versions: [1, 2, 3, 4, 5],
        label: window.i18n.__('Connexion'),
        type: 'component',
        component: 'connection',
        coloredIcon: 'settings-star',
        data: {
            thirdid: '{linkedid}',
        },
    },
    {
        id: 'sellsyadmin',
        versions: [1, 2],
        label: window.i18n.__('SellsyAdmin'),
        type: 'component',
        component: 'corporation-data-v2',
        data: {
            thirdid: '{linkedid}',
        },
    },
    {
        id: 'sam',
        versions: [3, 4, 5],
        label: window.i18n.__('SAM'),
        type: 'component',
        component: 'corporation-data-v3',
        coloredIcon: 'user-hexagon',
        data: {
            canEditUtm: '{canEditUtm}',
            canManageThirdPayer: '{canManageThirdPayer}',
            canBlockUnblockAccount: '{canBlockUnblockAccount}',
            canDisableSalesCart: '{canDisableSalesCart}',
            canDisableSaasBilling: '{canDisableSaasBilling}',
            canDisableTrialImportLimit: '{canDisableTrialImportLimit}',
            canUnlinkCorp: '{canUnlinkCorp}',
            canSynchronizeDataOnThird: '{canSynchronizeDataOnThird}',
            canChurnCustomer: '{canChurnCustomer}',
            corporation: '{corpid}',
            thirdPayerId: '{thirdPayerId}',
            thirdPayerName: '{thirdPayerName}',
            displayTrialBanner: '{displayTrialBanner}',
            thirdId: '{thirdId}',
            maintenance: '{maintenance}',
        },
    },
];

var headerActions = [
    {
        label: window.i18n.__('Modifier la société'),
        type: 'js',
        value: 'javascript:Third.edit({id})',
        permission: 'can_edit',
    },
    {
        label: window.i18n.__('Supprimer la société'),
        type: 'js',
        value: "javascript:Third.deleteThird({id}, '{can_delete_people}', '{type}')",
        permission: 'can_delete',
    },
    {
        label: window.i18n.__("Compléter via l'annuaire"),
        type: 'js',
        value: 'javascript:CompanySearch.modalUpdate({id})',
        permission: 'can_edit',
        display: 'can_company_search',
    },
    {
        label: window.i18n.__('Archiver la société'),
        type: 'js',
        value: "javascript:Third.singleUpdateState({id}, 'N')",
        permission: 'can_edit',
        display: 'can_show_action_archive',
    },
    {
        label: window.i18n.__('Restaurer la société'),
        type: 'js',
        value: "javascript:Third.singleUpdateState({id}, 'Y')",
        permission: 'can_edit',
        display: 'can_show_action_unarchive',
    },
    {
        label: window.i18n.__('Transformer en prospect'),
        type: 'js',
        value: "javascript:Third.transformThird('prospect', {id}, '');",
        permission: 'can_transform_to_prospect',
        display: 'can_show_action_transform_to_prospect',
    },
    {
        label: window.i18n.__('Transformer en client'),
        type: 'js',
        value: "javascript:Third.transformThird('client', {id}, '');",
        permission: 'can_transform_to_client',
        display: 'can_show_action_transform_to_client',
    },
    {
        label: window.i18n.__('Transformer en société'),
        type: 'js',
        value: "javascript:Third.transformOneThirdType({id}, 'corporation');",
        permission: 'can_transform_to_third',
        display: 'can_show_action_transform_to_third',
    },
    {
        label: window.i18n.__('Télécharger la VCard'),
        type: 'js',
        value: "javascript:Utils.relocate('/?_f=third&action=vcard&thirdid={id}')",
        permission: true,
    },
    {
        label: window.i18n.__('Ajouter du score'),
        type: 'js',
        value: "javascript:ScoringEvent.addScore({id}, {main_tpcid}, '" + location.href + "');",
        permission: 'can_edit',
        display: 'can_add_prospection_score',
    },
    {
        label: window.i18n.__('Modifier le logo de la société'),
        type: 'function',
        value: 'uploadAvatar',
        permission: true,
    },
    {
        label: window.i18n.__("Envoyer les identifiants pour l'espace client"),
        type: 'js',
        value: 'javascript:Third.sendContactPwd({main_tpcid}, {id})',
        permission: 'can_create_sellsy_access',
        display: 'can_create_sellsy_access',
    },
    {
        label: window.i18n.__('Fermer son accès'),
        type: 'js',
        value: 'javascript:Third.closeThirdAccess({main_tpcid}, {id})',
        permission: 'can_remove_sellsy_access',
        display: 'can_remove_sellsy_access',
    },
    {
        label: window.i18n.__('Recevoir la liste des traitements'),
        type: 'js',
        value: "javascript:Third.exportRegister('third', '{id}');",
        permission: 'can_download_treatments_list_via_menu',
        display: 'can_download_treatments_list_via_menu',
    },
];

var contactsActions = [
    {
        label: window.i18n.__('Voir'),
        type: 'link',
        link: '/?_f=people&id={id}',
        permission: true,
    },
    {
        label: window.i18n.__('Modifier'),
        type: 'js',
        link: "javascript:People.edit('thirdOverview', {id})",
        permission: 'can_edit',
    },
    {
        label: window.i18n.__("Activer l'accès à l'espace client"),
        type: 'js',
        link: 'javascript:Third.openThirdAccess({contactid}, {linkedid})',
        permission: 'can_manage_access',
        hide: function (item) {
            return item.hasClientArea || !item.email;
        },
    },
    {
        label: window.i18n.__("Désactiver l'accès à l'espace client"),
        type: 'js',
        link: 'javascript:Third.closeThirdAccess({contactid}, {linkedid})',
        permission: 'can_manage_access',
        hide: function (item) {
            return !item.hasClientArea;
        },
    },
    {
        label: window.i18n.__('Définir en tant que contact principal'),
        type: 'vuejs',
        link: 'defineMainContact',
        permission: 'can_edit',
        display: 'can_show_define_main_contact',
        filter: function (item) {
            return !item.mainContact;
        },
    },
    {
        label: window.i18n.__('Définir en tant que contact de facturation'),
        type: 'vuejs',
        link: 'defineBillingContact',
        permission: 'can_edit',
        hide: function (item) {
            return item.billingContact;
        },
    },
    {
        label: window.i18n.__('Définir en tant que contact de relance'),
        type: 'vuejs',
        link: 'defineDunningContact',
        permission: 'can_edit',
        filter: function (item) {
            return !item.mainContactDunning;
        },
    },
    // {
    //     label: window.i18n.__("Envoyer les identifiants pour l'espace client"),
    //     type: "js",
    //     value: "javascript:Third.sendContactPwd('{contactid}')",
    //     permission: "can_edit"
    // },
    {
        label: window.i18n.__('Délier le contact'),
        type: 'js',
        link: "javascript:People.removeLinked('{id}', '{contactid}')",
        permission: 'can_edit',
    },
    {
        label: window.i18n.__('Supprimer'),
        type: 'js',
        link: "javascript:People.deleteOne('{id}', 'newoverview', '{csrfToken}');",
        permission: 'can_edit',
        hide: function (item) {
            return item.billingContact;
        },
    },
];

var mainContactsActions = [
    {
        label: window.i18n.__('Voir'),
        type: 'link',
        link: '/?_f=people&id={id}',
        permission: true,
    },
    {
        label: window.i18n.__('Modifier'),
        type: 'js',
        link: "javascript:People.edit('thirdOverview', {id})",
        permission: 'can_edit',
    },
    {
        label: window.i18n.__("Activer l'accès à l'espace client"),
        type: 'js',
        link: 'javascript:Third.openThirdAccess({contactid}, {linkedid})',
        permission: 'can_manage_access',
        hide: function (item) {
            return item.hasClientArea || !item.email;
        },
    },
    {
        label: window.i18n.__("Désactiver l'accès à l'espace client"),
        type: 'js',
        link: 'javascript:Third.closeThirdAccess({contactid}, {linkedid})',
        permission: 'can_manage_access',
        hide: function (item) {
            return !item.hasClientArea;
        },
    },
    {
        label: window.i18n.__('Définir en tant que contact de facturation'),
        type: 'vuejs',
        link: 'defineBillingContact',
        permission: 'can_edit',
        hide: function (item) {
            return item.billingContact;
        },
    },
    {
        label: window.i18n.__('Définir en tant que contact de relance'),
        type: 'vuejs',
        link: 'defineDunningContact',
        permission: 'can_edit',
        //display: "can_show_define_main_contact",
        filter: function (item) {
            return !item.mainContactDunning;
        },
    },
    {
        label: window.i18n.__('Délier le contact'),
        type: 'js',
        link: "javascript:People.removeLinked('{id}', '{contactid}')",
        permission: 'can_edit',
    },
];

var sellsyAdminContactActions = [
    {
        id: 'staffType',
        label: window.i18n.__('Changer type de staff'),
        type: 'group',
        link: '',
        permission: 'can_edit',
        childrens: [
            {
                label: window.i18n.__('Regular'),
                value: 'regular',
                type: 'js',
                link: "javascript:SellsyAdmin.updateStaffType('{staffid}', '{corpid}', 'regular')",
                disabled: false,
            },
            {
                label: window.i18n.__('Temporary'),
                value: 'temporary',
                type: 'js',
                link: "javascript:SellsyAdmin.updateStaffType('{staffid}', '{corpid}', 'temporary')",
                disabled: false,
            },
            {
                label: window.i18n.__('Sellsy'),
                value: 'sellsy',
                type: 'js',
                link: "javascript:SellsyAdmin.updateStaffType('{staffid}', '{corpid}', 'sellsy')",
                disabled: false,
            },
        ],
    },
    {
        id: 'isDecisionMaker',
        label: window.i18n.__('Est décisionnaire'),
        type: 'js',
        link: 'javascript:SellsyAdmin.staffEnableAsDecisionMaker({corpid},{staffid})',
        permission: 'can_edit',
        filter: function (item) {
            return item.sellsyadmin.staff_status === 'ok';
        },
    },
    {
        id: 'isNotDecisionMaker',
        label: window.i18n.__("N'est pas décisionnaire"),
        type: 'js',
        link: 'javascript:SellsyAdmin.staffDisableAsDecisionMaker({corpid},{staffid})',
        permission: 'can_edit',
        filter: function (item) {
            return item.sellsyadmin.staff_status === 'ok';
        },
    },
    {
        id: 'blockStaff',
        label: window.i18n.__('Bloquer le staff'),
        type: 'js',
        link: "javascript:SellsyAdmin.updateStaffStatus({corpid}, {staffid}, 'blocked')",
        permission: 'can_edit',
    },
    {
        id: 'unblockStaff',
        label: window.i18n.__('Débloquer le staff'),
        type: 'js',
        link: "javascript:SellsyAdmin.updateStaffStatus({corpid}, {staffid}, 'ok')",
        permission: 'can_edit',
    },
    {
        id: 'changeCorpOwner',
        label: window.i18n.__('Définir comme propriétaire du compte Sellsy'),
        type: 'vuejs',
        link: 'defineAsCorporationOwner',
        permission: ['can_edit', 'can_manage_corporation_owner'],
        filter: function (item) {
            return item.sellsyadmin.staff_status === 'ok';
        },
    },
];

var addressesActions = [
    {
        label: window.i18n.__('Modifier'),
        type: 'vuejs',
        emitBus: false,
        link: 'openAddress',
        permission: 'can_edit_addresses',
    },
    {
        label: window.i18n.__("Définir en tant qu'adresse de facturation"),
        type: 'vuejs',
        link: 'defineInvoicingAddress',
        permission: 'can_edit_addresses',
        filter: function (item) {
            return !item.isMainInvoicingAddress;
        },
    },
    {
        label: window.i18n.__("Définir en tant qu'adresse de livraison"),
        type: 'vuejs',
        link: 'defineDeliveryAddress',
        permission: 'can_edit_addresses',
        filter: function (item) {
            return !item.isMainDeliveryAddress;
        },
    },
    {
        label: window.i18n.__('Supprimer'),
        type: 'vuejs',
        link: 'deleteItem',
        permission: 'can_delete_addresses',
    },
];

var bankActions = [
    {
        id: 'edit', // Modifier le RIB
        label: window.i18n.__('Modifier'),
        type: 'js',
        link: "javascript:BankAccount.edit({baid}, 'third', {thirdid})",
        permission: 'can_edit_rib',
    },
    {
        id: 'delete',
        label: window.i18n.__('Supprimer'), // Supprimer le RIB
        type: 'js',
        link: 'javascript:BankAccount.deleteOne({baid})',
        permission: 'can_delete_rib',
    },
    {
        id: 'defineMainAccount',
        label: window.i18n.__('Définir en tant que compte principal'),
        type: 'vuejs',
        link: 'defineMainAccount',
        permission: true,
    },
    {
        id: 'add_card', // Ajouter une carte bancaire
        permission: 'can_add_card',
    },
    {
        id: 'delete_card', // Supprimer une carte bancaire
        permission: 'can_delete_card',
    },
];

var backlink = [
    {
        type: 'client',
        url: '/thirds/client',
        label: window.i18n.__('Sociétés'),
    },
    {
        type: 'prospect',
        url: '/thirds/prospect',
        label: window.i18n.__('Sociétés'),
    },
    {
        type: 'supplier',
        url: '/thirds/supplier',
        label: window.i18n.__('Sociétés'),
    },
];

var routes = [
    {
        id: 'favorite',
        value: '/rest/thirds/{type}/overviews/favorites',
    },
    {
        id: 'activityform',
        value: '/rest/thirds/{id}/activity',
    },
    {
        id: 'save',
        value: '/rest/thirds/{id}/{type}',
    },
    {
        id: 'bank',
        value: '/rest/thirds/{id}/bankingdatas',
    },
];

var object = {
    idName: 'thirdid',
};

var agendaViewConfig = {
    relatedtype: 'third',
    nameCallbackFunction: 'Third.loadAgendaTab',
    prefixXsl: 'third',
};

const systemPaydatesWithEndOfMonth = ['30days', '45days', '60days', '90days'];

export {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    sellsyAdminContactActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    object,
    moreNav,
    // SellsyAdmin
    sellsyAdminCommonTabs,
    samTabs,
    agendaViewConfig,
    systemPaydatesWithEndOfMonth,
};
